import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import StarRating from '../../../../library/star-rating/star-rating';
import {
  CheckCircleSolidIcon,
  MapMarkerAltSolidIcon,
  TimesCircleSolidIcon
} from '../../../../shared/icons/icons';
import RatingGauge from '../../../rating-gauge/rating-gauge';
import ReviewFeedback from '../review-feedback/review-feedback';

import styles from './review.scss';

function Review(props) {
  const {
    answers,
    city,
    comments,
    date,
    details,
    heading,
    helpfulCount,
    id,
    isFeedbackSubmitted,
    isRecommended,
    notHelpfulCount,
    notRecommendedMessage,
    onHelpfulClick,
    rating,
    recommendedMessage,
    reviewerName,
    state,
    subHeading
  } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['reviewer']}>
        <div className={styles['heading']}>
          {heading}
          <br />
          {subHeading && (
            <span className={styles['sub-heading']}>{subHeading}</span>
          )}
        </div>

        <div className={styles['reviewer-rating']}>
          <StarRating rating={rating} />
        </div>

        {typeof reviewerName === 'string' && (
          <span className={styles['reviewer-name']}>
            {reviewerName || 'Anonymous'}
          </span>
        )}

        {city && state && (
          <span>
            <MapMarkerAltSolidIcon />
            &nbsp;{city}, {state}
          </span>
        )}
      </div>

      <div className={styles['details']}>
        <div className={styles['recommendation']}>
          {isRecommended ? (
            <span className={styles['recommended']}>
              <CheckCircleSolidIcon className={styles['recommend-icon']} />
              {recommendedMessage && (
                <span className={styles['recommend-message']}>
                  {recommendedMessage}
                </span>
              )}
            </span>
          ) : (
            <span className={styles['not-recommended']}>
              <TimesCircleSolidIcon className={styles['recommend-icon']} />
              {notRecommendedMessage && (
                <span className={styles['recommend-message']}>
                  {notRecommendedMessage}
                </span>
              )}
            </span>
          )}
          <span className={styles['date']}>
            {format(date || '', 'M/D/YYYY')}
          </span>
        </div>

        {Array.isArray(details) && (
          <ul className={styles['details-list']}>
            {details.map((detail, idx) => (
              <li className={styles['details-list-item']} key={`dl-${idx}`}>
                <span className={styles['detail-label']}>{detail?.label}:</span>
                {detail?.value}
              </li>
            ))}
          </ul>
        )}

        <div className={styles['rating-breakdown']}>
          {Array.isArray(answers) &&
            answers.map((answer, idx) => (
              <RatingGauge
                className={styles['rating-gauge']}
                key={`rba-${idx}`}
                label={answer.label}
                rating={answer.rating}
              />
            ))}
        </div>

        <p
          className={styles['comments']}
          dangerouslySetInnerHTML={{
            __html: comments
          }}
        />

        <ReviewFeedback
          helpfulCount={helpfulCount}
          id={id}
          isFeedbackSubmitted={isFeedbackSubmitted}
          notHelpfulCount={notHelpfulCount}
          onHelpfulClick={onHelpfulClick}
        />
      </div>
    </div>
  );
}

Review.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      rating: PropTypes.number
    })
  ),
  city: PropTypes.string,
  comments: PropTypes.string,
  date: PropTypes.string,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  heading: PropTypes.string,
  helpfulCount: PropTypes.number,
  id: PropTypes.string,
  isFeedbackSubmitted: PropTypes.bool,
  isRecommended: PropTypes.bool,
  notHelpfulCount: PropTypes.number,
  notRecommendedMessage: PropTypes.string,
  onHelpfulClick: PropTypes.func,
  rating: PropTypes.number,
  recommendedMessage: PropTypes.string,
  reviewerName: PropTypes.string,
  state: PropTypes.string,
  subHeading: PropTypes.string
};

export default Review;
